import React from 'react';
import { Redirect } from 'react-router-dom';

import User from 'Services/User';

/**
 * @function HasScope
 * @param {*|JSX.Element} component
 * @return {*|JSX.Element}
 * @constructor
 */
export default ({ component }) => {
    // Force the user to the profile page whilst the reg-only site is in-progress.

    if(process.env.MIX_APP_PHASE == 1) {
        return <Redirect to="/profile" />;
    }

    const canAccess = User.data.attending !== null;

    return canAccess ? User.data.registered_at ? component : <Redirect to="/settings/profile" /> :
        <Redirect to="/profile" />;
};
